import React from "react";
import styled from "styled-components";

const InputWrapper = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
  color: #222;
  cursor: pointer;
`;

const StyledInput = styled.input`
  accent-color: #ff0102;
  width: ${({ type }) => (type === "checkbox" ? "18px" : "100%")};
  height: ${({ type }) => (type === "checkbox" ? "18px" : "auto")};
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: ${({ type }) => (type === "checkbox" ? "0" : "8px 10px")};
  outline: none;
  font-size: 0.95rem;

  &:focus {
    border-color: #ff0102;
  }
`;

export default function Input({ type = "text", value, onChange, checkLabel, ...props }) {
    const normalizedValue = type === "checkbox" ? Boolean(value) : (value ?? "");

    return (
        <InputWrapper>
            <StyledInput
                type={type}
                checked={type === "checkbox" ? normalizedValue : undefined}
                value={type !== "checkbox" ? normalizedValue : undefined}
                onChange={onChange}
                {...props}
            />
            {checkLabel && <span>{checkLabel}</span>}
        </InputWrapper>
    );
}
